import { Input } from '@angular/core';
import { ConsolidatedPhoneReportComponent } from '../consolidated-phone-report/consolidated-phone-report.component';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardService } from 'ngx-clipboard';
import { HttpService } from 'src/app/http.service';
import { PreferenceService } from 'src/app/preference.service';
import { PlayerFormComponent } from '../player-form/player-form.component';
import { UnknownPaymentFormComponent } from '../unknown-payment-form/unknown-payment-form.component';
import { PlayerProfitComponent } from '../player-profit/player-profit.component';
import { LuckyDrawModalComponent } from '../lucky-draw-modal/lucky-draw-modal.component';
import { CommissionModalComponent } from '../commission-modal/commission-modal.component';
import { PlayerDailyComponent } from '../player-daily/player-daily.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PlayerTransactionHistoryComponent } from '../player-transaction-history/player-transaction-history.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PromotionLockComponent } from '../promotion-lock/promotion-lock.component';
import { GameLockComponent } from '../game-lock/game-lock.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AgentWalletComponent } from '../agent-wallet/agent-wallet.component';
import { TopupModalComponent } from '../topup-modal/topup-modal.component';
import { WithdrawModalComponent } from '../withdraw-modal/withdraw-modal.component';
import { BankerWalletnComponent } from '../banker-walletn/banker-walletn.component';
import { ReferralListComponent } from '../referral-list/referral-list.component';
import { PromotionConditionsComponent } from '../promotion-conditions/promotion-conditions.component';
import { PlayerGameLogComponent } from '../player-game-log/player-game-log.component';
import { PlayerAgentLogComponent } from '../player-agent-log/player-agent-log.component';
import { PlayerSmsLogComponent } from '../player-sms-log/player-sms-log.component';
import { ReferralTreeModalComponent } from '../referral-tree-modal/referral-tree-modal.component';
import { DownlineDepositWithdrawModalComponent } from '../downline-deposit-withdraw-modal/downline-deposit-withdraw-modal.component';
import { PlayerDwApprovalComponent } from '../player-dw-approval/player-dw-approval.component';

@Component({
  selector: 'app-wallet-topup-withdraw',
  templateUrl: './wallet-topup-withdraw.component.html',
  styleUrls: ['./wallet-topup-withdraw.component.scss']
})
export class WalletTopupWithdrawComponent implements AfterViewInit {
  @Input() consolidatedReportCompanyUuid = '';
  openConsolidatedReport() {
    const modal = this.ngbModal.open(ConsolidatedPhoneReportComponent, {size:'lg'});
    modal.componentInstance.playerUuid = this.player.uuid;
    modal.componentInstance.reportCompanyUuid = this.consolidatedReportCompanyUuid;
  }

  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('search') search;
  @ViewChild("th") th: PlayerTransactionHistoryComponent;
  @ViewChild("th") th1: PlayerTransactionHistoryComponent;
  @ViewChild("payout") payout: NgSelectComponent

  public company_uuid;
  public player_search;
  public player_uuid;
  public data: any = { process: 'topup' };
  public is_searching_player: any = false
  public current_company: any = {}
  public setting: any = {}
  public players: any = [];
  public player: any = {};
  public referral_rate: any = 0;
  public banks: any = [];
  public player_banks: any = [];
  public is_loading_function: any = false
  public copy_text_append: any;
  public copy_text: any;
  public is_copy: boolean = false;
  public wallet_balance: any;
  public is_loading_bank: boolean = true;
  public referral_wallet: any;
  public agent_wallet: any;
  public first_load = false;

  // ── Player action menu favourites ──
  // The action toolbar (Profile / Referral / Topup / …) is data-driven so the
  // operator can pin the actions they use most. Favourites are stored per-user
  // (PreferenceService) and shared across the wallet topup/withdraw pages.
  //   menuCustomize = user is picking which actions to pin (stars shown)
  //   showAllMenu   = the favourites-only view is temporarily expanded
  private static readonly MENU_FAV_SCOPE = 'player_action_menu_favorites';
  // Common-usage actions pinned to a fixed first line above the Customize bar.
  // These are always shown, never part of the customisable/favouritable grid.
  // Topup / Withdraw / D/W Approve are the day-to-day workflow actions and live
  // on the fixed line. Money actions still carry their explicit permission.
  private static readonly COMMON_MENU_KEYS = ['topup', 'withdraw', 'dw_approval'];
  public menuFavorites: string[] = [];
  public menuCustomize = false;
  public showAllMenu = false;
  public playerMenu: any[] = [];
  public visiblePlayerMenu: any[] = [];
  public commonPlayerMenu: any[] = [];
  // Granted-permission map for the logged-in admin (`{ path: 1, … }`). Sourced
  // from /admin/user/permission/hidden (getHiddenPermission) — the SAME map the
  // route guard uses to allow/deny pages. Super admins get every path, so they
  // see every action.
  //
  // Gating policy: actions that directly control a player's money balance carry
  // a `perm` and are hidden unless the admin holds it. View/log/promotion actions
  // are not gated here.
  // `permLoaded` gates this: until the map arrives we show everything
  // (fail-open) so a slow/failed fetch can never permanently hide actions.
  public grantedPermissions: { [path: string]: any } = {};
  private permLoaded = false;

  constructor(private http: HttpService, private ngbModal: NgbModal, private clipboardApi: ClipboardService, private activatedRoute: ActivatedRoute, private _location: Location, private router: Router, private pref: PreferenceService) {
    this.company_uuid = this.http.getStaticSelectedCompany();
    this.current_company = this.http.getSelecetdCompanyDetail()

    this.buildPlayerMenu();
    this.menuFavorites = this.pref.get<string[]>(WalletTopupWithdrawComponent.MENU_FAV_SCOPE, []);
    this.rebuildVisibleMenu();
    this.loadPermissions();

    this.companySetting();

    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (v: any) => {
      if (v.filter) {
        this.player_search = v.filter;
      }
      if (v.player) {
        this.player_uuid = v.player;
        await this.getPlayer();
      }

      if (!v.player) {
        this.player_uuid = null;
        this.player = {};
        this.wallet_balance = null;
        this.data = { process: 'topup' };
        // No navigation here: preserve workspace and history query parameters.
        if (this.first_load) {
          setTimeout(() => {
            this.searchPlayerListener()
          }, 100);
        }
      } else {
        this.first_load = true;
      }
    })
  }


  ngAfterViewInit(): void {
    this.searchPlayerListener()
  }

  searchPlayerListener() {
    try {
      this.search.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(500))
        .pipe(distinctUntilChanged())
        .subscribe((v: any) => {
          if (!v || v.length < 3) {
            return;
          }

          this.searchPlayer(v)
        })
    } catch (error) {
    }
  }

  async companySetting() {
    let y: any = await this.http.post("/admin/company/setting");
    this.setting = y.setting;
    // domain may have arrived now — re-evaluate the "Login" action visibility
    this.rebuildVisibleMenu();
  }

  // ── Player action menu (favouritable) ──
  // Stable config built once. Each item's `run` reads `this.player` at click
  // time, so it works for whichever player is currently selected.
  private buildPlayerMenu() {
    this.playerMenu = [
      { key: 'profile', icon: 'fa-user', label: 'Profile', run: () => this.editPlayer(this.player) },
      { key: 'referral', icon: 'fa-users', label: 'Referral', run: () => this.referralModal() },
      { key: 'referral_tree', icon: 'fa-sitemap', label: 'Referral Tree', run: () => this.referralTreeModal() },
      { key: 'profit', icon: 'fa-line-chart', label: 'Profit', run: () => this.playerProfit() },
      { key: 'dw', icon: 'fa-exchange', label: 'D/W', run: () => this.downlineDepositWithdraw() },
      { key: 'daily', icon: 'fa-calendar', label: 'Daily', run: () => this.getDaily() },
      { key: 'topup', icon: 'fa-arrow-up', label: 'Topup', perm: 'seamless-wallet-topup', run: () => this.topupModal(this.player) },
      { key: 'withdraw', icon: 'fa-arrow-down', label: 'Withdraw', perm: 'seamless-wallet-withdraw', run: () => this.withdrawModal(this.player) },
      { key: 'manual_wallet', icon: 'fa-hand-paper-o', label: 'Manual Wallet', perm: 'manual-topup-withdraw', run: () => this.gotoWalletPage('manual-topup-withdraw') },
      { key: 'transfer_wallet', icon: 'fa-exchange', label: 'Transfer Wallet', perm: 'auto-topup-withdraw', run: () => this.gotoWalletPage('auto-topup-withdraw') },
      { key: 'credit', icon: 'fa-credit-card', label: 'Credit', perm: 'player-credit', run: () => this.gotoWalletPage('player-credit') },
      { key: 'lucky_draw', icon: 'fa-gift', label: 'Lucky Draw', run: () => this.luckyDraw() },
      { key: 'promotion', icon: 'fa-bullhorn', label: 'Promotion', run: () => this.getPromotion() },
      { key: 'eligibility', icon: 'fa-bullhorn', label: 'Eligibility', run: () => this.getPromotionConditions() },
      { key: 'dw_approval', icon: 'fa-check-square-o', label: 'D/W Approve', run: () => this.dwApproval() },
      { key: 'ref_wallet', icon: 'fa-percent', label: 'Ref. Wallet', perm: 'referral-adjustment', run: () => this.commissionModal() },
      { key: 'agent_wallet', icon: 'fa-wallet', label: 'Agent Wallet', perm: 'agent-adjustment', run: () => this.agentWallet() },
      { key: 'agent_log', icon: 'fa-line-chart', label: 'Agent Log', run: () => this.openAgentLog() },
      { key: 'sms_tac', icon: 'fa-commenting', label: 'SMS TAC', run: () => this.openSmsLog() },
      { key: 'game_log', icon: 'fa-gamepad', label: 'Game Log', run: () => this.openGameLog() },
      { key: 'login', icon: 'fa-sign-in', label: 'Login', run: () => this.loginAccount(), show: () => !!(this.current_company && this.current_company.domain) },
    ];
  }

  // Fetch the logged-in admin's granted permissions once, then re-filter the
  // menu so any action the operator disabled in staff setup drops off. Runs
  // async from the constructor; on failure we leave the menu fail-open.
  private async loadPermissions() {
    try {
      const hidden: any = await this.http.getHiddenPermission();
      this.grantedPermissions = hidden && typeof hidden === 'object' ? hidden : {};
    } catch (e) {
      this.grantedPermissions = {};
    }
    this.permLoaded = true;
    this.rebuildVisibleMenu();
  }

  // Whether a menu item is visible to the current admin. `show()` is the
  // pre-existing per-item guard (e.g. Login needs a domain); `perm` is the
  // permission-setup gate. Until permissions load we don't apply the `perm`
  // gate (fail-open) so a slow fetch never hides a legitimate action.
  isMenuItemVisible(item: any): boolean {
    if (!item) return false;
    if (item.show && !item.show()) return false;
    if (this.permLoaded && item.perm && !this.grantedPermissions[item.perm]) return false;
    return true;
  }

  // Rebuild the cached visible list (never recompute in the template — a getter
  // there recreates arrays every change-detection pass and thrashes *ngFor).
  private rebuildVisibleMenu() {
    const all = (this.playerMenu || []).filter((it: any) => this.isMenuItemVisible(it));
    const commonKeys = WalletTopupWithdrawComponent.COMMON_MENU_KEYS;
    // fixed first line — common-usage actions (Topup / Withdraw), original order
    this.commonPlayerMenu = commonKeys
      .map((k) => all.find((it: any) => it.key === k))
      .filter((it: any) => !!it);
    // everything else is the customisable grid below the toolbar
    const shown = all.filter((it: any) => !commonKeys.includes(it.key));
    if (this.menuCustomize) {
      // picking favourites — show every action so any can be pinned
      this.visiblePlayerMenu = shown;
      return;
    }
    if (this.hasMenuFavorites && !this.showAllMenu) {
      // collapsed: favourites only
      this.visiblePlayerMenu = shown.filter((it: any) => this.isMenuFav(it.key));
      return;
    }
    // full menu, favourites floated to the front (original order within each part)
    const favs = shown.filter((it: any) => this.isMenuFav(it.key));
    const rest = shown.filter((it: any) => !this.isMenuFav(it.key));
    this.visiblePlayerMenu = [...favs, ...rest];
  }

  get hasMenuFavorites(): boolean {
    return this.menuFavorites && this.menuFavorites.length > 0;
  }

  isMenuFav(key: string): boolean {
    return this.menuFavorites.includes(key);
  }

  toggleMenuFav(item: any, ev?: Event) {
    if (ev) { ev.preventDefault(); ev.stopPropagation(); }
    if (!item || !item.key) return;
    const i = this.menuFavorites.indexOf(item.key);
    if (i >= 0) {
      this.menuFavorites.splice(i, 1);
    } else {
      this.menuFavorites.push(item.key);
    }
    this.menuFavorites = [...this.menuFavorites];
    this.pref.set(WalletTopupWithdrawComponent.MENU_FAV_SCOPE, this.menuFavorites);
    this.rebuildVisibleMenu();
  }

  toggleMenuCustomize() {
    this.menuCustomize = !this.menuCustomize;
    if (this.menuCustomize) this.showAllMenu = true;
    this.rebuildVisibleMenu();
  }

  toggleShowAllMenu() {
    this.showAllMenu = !this.showAllMenu;
    this.rebuildVisibleMenu();
  }

  runMenu(item: any) {
    if (this.menuCustomize) return;
    if (item && item.run) item.run();
  }

  trackMenu(_: number, item: any) {
    return item.key;
  }

  async searchPlayer(data: any) {
    delete this.data.player_uuid;
    this.is_searching_player = true;
    this.players = await this.http.post("/admin/player/search", { search: data })
    this.is_searching_player = false;
  }

  async getPlayer() {
    let y: any = await this.http.post("/admin/player/get/v2", { player_uuid: this.player_uuid })

    this.player = y;
    this.player_search = null;
    this.data.player_game_id = null;
    this.data.game_id = null;
    this.data.player_uuid = this.player_uuid;

    this.referral_rate = parseFloat(this.player.referral_rate ?? this.current_company.referral_rate);

    await this.playerWalletBalance();
    await this.getBankDetail();
  }

  editPlayer(player = null) {
    let modal: any = this.ngbModal.open(PlayerFormComponent, { size: "md", backdrop: 'static' });

    if (player && player.uuid) {
      modal.componentInstance.playerUUID = player.uuid;
    }

    modal.componentInstance.fullwidth = true;
    modal.componentInstance.successEvent.subscribe(async (v: any) => {
      await this.getPlayer();
      delete this.data.game_id
      modal.close();
    })

    modal.componentInstance.closeEvent.subscribe(async (v: any) => {
      modal.close();
    })

  }


  async getBankDetail() {
    this.is_loading_bank = true;
    let y: any = await this.http.post("/admin/player/bank-detail", this.data)

    this.banks = y.banks;
    this.player_banks = y.player_banks;

    this.is_loading_bank = false;
  }

  getUnknownPayment() {
    let modal: any = this.ngbModal.open(UnknownPaymentFormComponent, { size: "md" });
    modal.componentInstance.modal = true;
    modal.componentInstance.saveEvent.subscribe((v: any) => {
      modal.close()
    })
  }


  async selectPlayer(player_uuid) {
    this.player_search = null;
    this.data.player_uuid = player_uuid;
    this.data.player_game_id = null;
    this.data.game_id = null;

    this.router.navigate([], { queryParams: { player: player_uuid }, queryParamsHandling: 'merge' })

    this.player = this.players.find((v: any) => {
      return v.uuid == player_uuid;
    })

    this.referral_rate = parseFloat(this.player.referral_rate ?? this.current_company.referral_rate);

    await this.playerWalletBalance();
    await this.getBankDetail();
  }

  async playerWalletBalance() {
    let y: any = await this.http.post("/admin/player/wallet-balance", this.player)
    this.wallet_balance = y.balance;
    this.referral_wallet = y.referral_wallet;
    this.agent_wallet = y.agent_wallet;
  }

  playerProfit() {
    if (this.consolidatedReportCompanyUuid) { this.openConsolidatedReport(); return; }
    let modal: any = this.ngbModal.open(PlayerProfitComponent, { size: "md" });
    modal.componentInstance.setPlaterUUID = this.player.uuid
  }

  downlineDepositWithdraw() {
    let modal: any = this.ngbModal.open(DownlineDepositWithdrawModalComponent, { size: "xl" });
    modal.componentInstance.playerUuid = this.player.uuid;
  }

  luckyDraw() {
    let modal: any = this.ngbModal.open(LuckyDrawModalComponent, { size: "xs" });
    modal.componentInstance.player = this.player;
    modal.componentInstance.saveEvent.subscribe((v: any) => {
      modal.close()
    })
  }

  commissionModal() {
    let modal: any = this.ngbModal.open(CommissionModalComponent, { size: "xs" });
    modal.componentInstance.playerUUID = this.player.uuid;
    modal.componentInstance.saveEvent.subscribe((v: any) => {
      modal.close()
    })
  }

  referralTreeModal() {
    let modal: any = this.ngbModal.open(ReferralTreeModalComponent, { size: "md" });
    modal.componentInstance.setPlayerUUID = this.player.uuid;
    modal.componentInstance.closeEvent.subscribe((v: any) => {
      modal.close()
    })
  }

  getDaily() {
    if (this.consolidatedReportCompanyUuid) { this.openConsolidatedReport(); return; }
    let modal: any = this.ngbModal.open(PlayerDailyComponent, { size: "md", backdrop: 'static' });
    modal.componentInstance.setUserUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe(() => {
      modal.close()
    })
  }

  openAgentLog() {
    let modal: any = this.ngbModal.open(PlayerAgentLogComponent, { size: 'xl', backdrop: 'static' });
    modal.componentInstance.setPlayer = this.player;
    modal.componentInstance.closeEvent.subscribe(() => {
      modal.close();
    });
  }

  openSmsLog() {
    let modal: any = this.ngbModal.open(PlayerSmsLogComponent, { size: 'lg', backdrop: 'static' });
    modal.componentInstance.setPlayer = this.player;
    modal.componentInstance.closeEvent.subscribe(() => {
      modal.close();
    });
  }

  openGameLog() {
    let modal: any = this.ngbModal.open(PlayerGameLogComponent, { size: 'xl', backdrop: 'static' });
    modal.componentInstance.setPlayer = this.player;
    modal.componentInstance.closeEvent.subscribe(() => {
      modal.close();
    });
  }

  getGameLock() {
    let modal: any = this.ngbModal.open(GameLockComponent, { size: "md", backdrop: 'static' });
    modal.componentInstance.setUserUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe(() => {
      modal.close()
    })
  }

  getPromotion() {
    let modal: any = this.ngbModal.open(PromotionLockComponent, { size: "md", backdrop: 'static' });
    modal.componentInstance.setUserUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe(() => {
      modal.close()
    })
  }

  async topup() {

    if ((!this.data.amount || this.data.amount <= 0) && !this.data.bonus) {
      this.data.amount = null;
      this.http.notify("Deposit Account or bonus be empty")
      return;
    }

    if (!this.data.deposit_bank && !this.data.topup_only) {
      this.http.notify("Select Deposit Account")
      return;
    }

    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/wallet/topup", this.data);
    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    await this.generateCopy("Deposit: " + this.data.amount + "\nBonus: " + this.data.bonus + "\n")

    this.data = { game_id: this.data.game_id, player_uuid: this.data.player_uuid, player_game_id: this.data.player_game_id }

    await this.getBankDetail();

    this.th.initTable();
    this.th1.initTable();
  }


  async withdraw() {

    if (!this.data.full_withdraw && ((!this.data.withdraw || this.data.withdraw < 0) && this.data.withdraw !== 0)) {
      this.http.notify("Withdraw amount is required.")
      return;
    }

    if (!this.data.withdraw_only && (!this.data.withdraw_to_account || !this.data.withdraw_from_account)) {
      this.http.notify("Select Account to Withdraw or create new account")
      return;
    }

    if (!this.data.withdraw_only && (this.data.withdraw_to_account == 'new' && (!this.data.withdraw_bank || !this.data.withdraw_account_no))) {
      this.http.notify("Withdraw Bank Name & Account number are required.")
      return;
    } else {
    }

    if (!this.data.withdraw_only && this.data.enabled_finance_charge && this.data.finance_charge == undefined) {
      this.http.notify("Finance charge option are required.")
      return;
    }

    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/wallet/withdraw", this.data);

    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    await this.generateCopy("Withdraw: " + y.amount + "\n")
    this.data = { game_id: this.data.game_id, player_uuid: this.data.player_uuid, player_game_id: this.data.player_game_id }

    this.th.initTable();
    this.th1.initTable();
    await this.getBankDetail();
  }


  async generateCopy(addon: any = false) {

    this.is_loading_function = true;

    let str: any = ""

    str += "Code:" + this.player.code + "\n";

    if (addon) {
      str += addon
    }

    str += this.copy_text_append

    this.clipboardApi.copyFromContent(str)

    this.is_loading_function = false;

    if (addon) {
      this.is_copy = true;
    }

    this.copy_text = str;

  }

  topupValueChange() {
    this.data.referral_commission = (this.data.amount * this.referral_rate) / 100;

    if (this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.data.point = (this.data.amount * parseFloat(this.setting.credit_calculation_rate)) / 100;
    }

  }

  topupOnlyChange() {
    delete this.data.amount;
    delete this.data.deposit_bank;
    delete this.data.point;
  }

  withdrawValueChange() {
    if (this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.data.withdraw_point = -1 * (this.data.withdraw * parseFloat(this.data.credit_calculation_rate)) / 100;
    }

    this.data.actual_pay_to_bank = this.data.withdraw
  }


  fcRateChange() {
    if (this.data.finance_charge == "true") {
      this.data.finance_charge_rate = this.setting.finance_charge_rate;
    } else {
      delete this.data.finance_charge_rate
    }
  }

  copyAccount() {

    let bank = this.player_banks.find((v: any) => {
      return v.id == this.data.withdraw_to_account
    })

    if (bank && bank.account) {
      this.clipboardApi.copyFromContent(bank.account)
    }
  }

  createNewAccount() {
    this.data.withdraw_to_account = "new"
    this.payout.close()
  }

  async loginAccount() {
    // iOS Safari only honors window.open() when it fires synchronously inside the
    // tap. The login token is fetched async first, so opening the tab afterwards is
    // blocked on iPhone. Reserve the tab now, then point it at the login URL once the
    // token resolves (navigating a held window handle is never popup-blocked).
    const win = window.open("", "_blank");

    let login: any = await this.http.post("/admin/player/login-account", { player_uuid: this.player.uuid });

    if (!login || !login.token) {
      if (win && !win.closed) { win.close(); }
      return;
    }

    const url = "https://" + this.current_company.domain + "/?player_access_token=" + login.token;
    if (win && !win.closed) {
      win.location.href = url;
    } else {
      window.open(url, "_blank");
    }
  }

  agentWallet() {
    let modal: any = this.ngbModal.open(AgentWalletComponent, { size: "md", backdrop: 'static' });
    modal.componentInstance.playerUUID = this.player.uuid
    modal.componentInstance.saveEvent.subscribe(() => {
      modal.close()
    })
    modal.componentInstance.closeEvent.subscribe((v: any) => {
      modal.close()
    })
  }

  back() {
    this._location.back();
  }

  // Jump to the Manual / Transfer Wallet Topup/Withdraw pages for the player that
  // is currently open on this Seemless page. The player uuid is carried on the
  // query string so the target page auto-selects them — the operator does not
  // have to search the same player again.
  gotoWalletPage(path: string) {
    if (!this.player || !this.player.uuid) { return; }
    this.router.navigate(['/lo', this.company_uuid, path], { queryParams: { player: this.player.uuid } });
  }

  resetPlayer() {
    this.router.navigate([], { queryParams: { player: null }, queryParamsHandling: 'merge' });
  }

  topupModal(player = null) {
    let modal: any = this.ngbModal.open(TopupModalComponent, { size: "md", backdrop: 'static' });
    modal.componentInstance.playerUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe(async (v: any) => {
      if (v) {
        await this.generateCopy(v)
        await this.getBankDetail();
        await this.playerWalletBalance();

        this.th.initTable();
        this.th1.initTable();
      }
      modal.close()
    })
  }

  async withdrawModal(player = null) {

    let y: any = await this.http.post("/admin/player/active-promotion/check", { player_uuid: this.player.uuid })
    if (y.status) {
      let aa = confirm("Player have active promotion. Please complete / cancel the promotion first. Proceed to cancel?");
      if (!aa) {
        return;
      }
    }

    let modal: any = this.ngbModal.open(WithdrawModalComponent, { size: "md", backdrop: 'static' });
    modal.componentInstance.playerUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe(async (v: any) => {
      if (v) {
        await this.generateCopy(v)
        await this.getBankDetail();
        await this.playerWalletBalance();

        this.th.initTable();
        this.th1.initTable();
      }
      modal.close()
    })
  }

  dwApproval() {
    let modal: any = this.ngbModal.open(PlayerDwApprovalComponent, { size: "xl", backdrop: 'static', scrollable: true });
    modal.componentInstance.setPlayer = this.player;
    modal.componentInstance.updatedEvent.subscribe((v: any) => {
      // Refresh the player's wallet balance after an approve/reject (a deposit
      // credits or a withdraw refund changes it).
      this.playerWalletBalance();
    });
    modal.componentInstance.closeEvent.subscribe((v: any) => {
      modal.close();
    });
  }

  getPromotionConditions() {
    let modal: any = this.ngbModal.open(PromotionConditionsComponent, { size: "lg", backdrop: 'static' });
    modal.componentInstance.playerUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe((v: any) => {
      modal.close()
    })
  }

  bankerWallet() {
    let modal: any = this.ngbModal.open(BankerWalletnComponent, { size: "md", backdrop: 'static' });
    modal.componentInstance.playerUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe((v: any) => {
      this.playerWalletBalance();
      modal.close()
    })
  }

  referralModal() {
    let modal: any = this.ngbModal.open(ReferralListComponent, { size: "lg" });
    modal.componentInstance.playerUUID = this.player.uuid
    modal.componentInstance.closeEvent.subscribe((v: any) => {
      modal.close()
    })
  }

}
